
<template>
  <div>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable width="600px">
      <v-card v-if="dialog">
        <v-card-title primary-title class="pa-0">
          <v-toolbar dark color="primary" >
            <v-toolbar-title>Novo usuário</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog()" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="createForm">
            <v-text-field label="Nome" v-model="edit_user.name" :rules="required"></v-text-field>
            <v-text-field label="Email" v-model="edit_user.email" :rules="required"></v-text-field>
            <v-select label="Tipo de usuário" item-value="value" item-text="text" :items="user_kind_options" v-model="edit_user.kind" :rules="required"></v-select>
            <v-text-field label="Departamento" v-model="department_name" v-if="department_name"></v-text-field>
            <select-department :create_user="true" @saveDepartment="handleSaveDepartment"></select-department>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="success" @click="editUser()"><v-icon left>mdi-check</v-icon>Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'EditUserDialog',
  components: {
    SelectDepartment: () => import('@/components/_execution/create/shared/NewExecutionDepartment.vue'),
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
    }
  },
  mixins: [
    validations
  ],
  data() {
    return {
      edit_user: {
        name: '',
        email: '',
        password: '',
        kind: null,
        department_ids: []
      },
      user_kind_options: [
        { text: 'Admin', value: 'admin' },
        { text: 'Comum', value: 'execute' }
      ],
      department_name: null
    }
  },
  mounted () {
    this.setEditUser();
  },
  methods: {
    setEditUser() {
      this.edit_user = {...this.user};
      this.department_name = this.user.main_dept_name
    },
    clearNewUser() {
      this.edit_user = {
        name: '',
        email: '',
        password: '',
        kind: null,
        department_ids: []
      }
    },
    async editUser() {
      if (this.$refs.createForm.validate() && this.edit_user.department_ids.length) {
        this.loading = true;
        await this.updateUser(this.edit_user)
        this.clearNewUser();
        this.loading = false;
        this.dialog = false;
      }
    },
    handleSaveDepartment(department) {
      this.edit_user.department_ids[0] = department.id;
      this.department_name = department.name;
      console.log(this.edit_user)
    },
    closeDialog() {
      this.clearNewUser();
      this.$emit('closeEditDialog')
    },
    ...mapActions({
      updateUser: 'User/update'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>